export type VideoType = "movie" | "tv" | "variety";

export interface Video {
  id: string;
  title: string;
  type: VideoType;
  year: number;
  region: string;
  genres: string[];
  director: string;
  cast: string[];
  rating: number;
  poster: string;
  summary: string;
  status: string;
  hot: number;
  updatedAt: string;
  tags: string[];
}

export const VIDEO_TYPE_LABEL: Record<VideoType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const VIDEO_TYPE_DESC: Record<VideoType, string> = {
  movie: "精选院线大片与口碑佳片，涵盖动作、悬疑、科幻、爱情等多种类型，高清在线观看。",
  tv: "热播剧集连续更新，古装、悬疑、都市、谍战一网打尽，追剧不掉线。",
  variety: "热门综艺、真人秀与音乐竞技节目，轻松解压，每周更新不断档。",
};